import { Component, QueryList, ContentChildren, AfterContentInit, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import * as fromRootStore from '@apps/root/store';
import { IAuroraState } from '@apps/aurora.state';

import { StepComponent } from './step/step.component';

@Component({
    selector: 'aa-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: [
        './wizard.component.scss'
    ],
    standalone: false
})
export class WizardComponent implements OnInit, AfterContentInit, OnDestroy
{
    private destroyator = new Subject();
    @ContentChildren(StepComponent) steps: QueryList<StepComponent>;
    @Input() justified: boolean = false;
    @Input() height: number = 50;
    @Input() nextWizardStep: () => any;
    @Output() selectedStep: EventEmitter<number> = new EventEmitter<number>();
    public height1: number;
    public activeId: number = 0;
    public nextDisabled: boolean = true;

    constructor (
        private store: Store<IAuroraState>,
        private actions: Actions
    )
    { }

    ngOnInit ()
    {
        this.height1 = this.height;
    }

    ngAfterContentInit ()
    {
        this.steps.forEach((step, idx) =>
        {
            step.stepId = idx;
        });

        const activeSteps: StepComponent[] = this.steps
            .filter((step: StepComponent) => step.active);

        if (activeSteps.length === 0)
        {
            this.activateStep(this.steps.first.stepId);
        }

        this.actions
            .pipe(
                ofType(fromRootStore.RootMiscStoreActions.RootWizardStepState),
                tap((params: { stepIdx: number, valid: boolean; }) =>
                {
                    Promise.resolve(null).then(() =>
                    {
                        const step = this.steps
                            .find((s) =>
                                s.stepId === params.stepIdx
                            );
                        step.valid = params.valid;
                        this.nextDisabled = !(this.activeId !== (this.steps.length - 1) && params.valid);
                    });
                }),
                takeUntil(this.destroyator)
            )
            .subscribe();

        this.actions
            .pipe(
                ofType(fromRootStore.RootMiscStoreActions.RootWizardStepEnabled),
                tap((params: { stepIdx: number, deactivated: boolean }) =>
                {
                    this.steps
                        .find((step) =>
                            step.stepId === params.stepIdx
                        )
                        .deactivated = params.deactivated;
                }),
                takeUntil(this.destroyator)
            )
            .subscribe();

        this.actions
            .pipe(
                ofType(fromRootStore.RootMiscStoreActions.RootWizardStepActivated),
                tap(({ stepIdx }: { stepIdx: number }) =>
                {
                    this.activateStep(stepIdx);
                }),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    clickNextStep (): void
    {
        this.store.dispatch(
            fromRootStore.RootMiscStoreActions.RootWizardNextStepButtonClicked({ stepIdx: this.activeId })
        );
    }

    public nextStep (next: number): void
    {
        this.activateStep(next);
    }

    /**
     *
     * @param {number} idx - l'index du step à activer
     */
    public activateStep (idx: number): void
    {
        Promise.resolve(null).then(() =>
        {
            const step = this.steps.find((item) => item.stepId === idx);

            step.disabled = false;

            this.steps.forEach(t => t.active = false);
            step.active = true;
            this.activeId = step.stepId;
            if (this.activeId === (this.steps.length - 1))
            {
                this.nextDisabled = true;
            }

            this.selectedStep.emit(idx);
        });
    }
}
